import { addAgenda, getAgendaList, updateAgenda, updateAgendaStatus, deleteEventAgenda, deleteEventAgendaFile } from '@/api/agenda'

const agenda = {
    state: {},
    mutations: {},
    actions: {

    AddAgenda({ commit }, data) {
        return new Promise((resolve, reject) => {
            addAgenda(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    GetAgendaList({ commit }, data) {
        return new Promise((resolve, reject) => {
            getAgendaList(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    UpdateAgenda({ commit }, data) {
        return new Promise((resolve, reject) => {
            updateAgenda(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
      },

      updateAgendaStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            updateAgendaStatus(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
      },  
      
      DeleteEventAgenda({ commit }, data) {
        return new Promise((resolve, reject) => {
            deleteEventAgenda(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
      },  

      DeleteEventAgendaFile({ commit }, data) {
        return new Promise((resolve, reject) => {
            deleteEventAgendaFile(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
      },

  },
}

export default agenda
